import { useState } from "react";
import { Printer, Eye, EyeSlash } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";

export const BatchBar = ({ selected, onClear, onDone, type, offsetMobile = true }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!selected.length) return null;

  const setPortalPrice = async (show) => {
    setBusy(true);
    try {
      const { data } = await api.post("/slabs/bulk-portal-price", { ids: selected, show });
      toast.success(
        `${show ? "Showing" : "Hiding"} portal price on ${data.updated} slab${
          data.updated === 1 ? "" : "s"
        }`,
      );
      onClear?.();
      onDone?.();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not update slabs");
    }
    setBusy(false);
  };

  return (
    <div
      data-testid="batch-bar"
      className={`no-print fixed left-0 right-0 z-30 border-t border-yellow-500/40 bg-zinc-900 p-3 ${
        offsetMobile ? "bottom-16 sm:bottom-0" : "bottom-0"
      }`}
    >
      <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-3 px-1">
        <span
          className="text-sm text-zinc-300"
          data-testid="batch-selected-count"
        >
          {selected.length} selected
        </span>
        <button
          data-testid="clear-selection-button"
          onClick={onClear}
          className="text-xs uppercase tracking-widest text-zinc-500 hover:text-white"
        >
          Clear
        </button>
        <div className="ml-auto flex flex-wrap items-center gap-2">
          {type === "slabs" && (
            <>
              <Button
                data-testid="batch-show-price-button"
                variant="outline"
                disabled={busy}
                onClick={() => setPortalPrice(true)}
                className="h-12 border-emerald-500/40 bg-transparent text-xs font-bold uppercase tracking-widest text-emerald-300 hover:bg-emerald-500/10"
              >
                <Eye size={18} weight="bold" className="mr-2" /> Show Price
              </Button>
              <Button
                data-testid="batch-hide-price-button"
                variant="outline"
                disabled={busy}
                onClick={() => setPortalPrice(false)}
                className="h-12 border-zinc-600 bg-transparent text-xs font-bold uppercase tracking-widest text-zinc-300 hover:bg-zinc-800"
              >
                <EyeSlash size={18} weight="bold" className="mr-2" /> Hide Price
              </Button>
            </>
          )}
          <Button
            data-testid="print-selected-button"
            onClick={() =>
              navigate(`/batch-print?type=${type}&ids=${selected.join(",")}`)
            }
            className="h-12 bg-indigo-500 text-xs font-bold uppercase tracking-widest text-white hover:bg-indigo-400"
          >
            <Printer size={18} weight="bold" className="mr-2" /> Print{" "}
            {selected.length} Labels
          </Button>
        </div>
      </div>
    </div>
  );
};
